import axios from '../../axios'

/*
 * 用户管理模块
 */

// 保存
export const save = (data) => {
  return axios({
    url: '/coach/save',
    method: 'post',
    data
  })
}
// 删除
export const batchDelete = (data) => {
  return axios({
    url: '/coach/delete',
    method: 'post',
    data
  })
}
// 分页查询
export const findPage = (data) => {
  return axios({
    url: '/coach/list',
    method: 'post',
    data
  })
}
// 详情
export const detailView = (data) => {
  return axios({
    url: '/coach/detail',
    method: 'post',
    data
  })
}
// 获取统一编号
export const handleGetNum = (data) => {
  return axios({
    url: '/coach/getCoachNum/' + data,
    method: 'post',
    data
  })
}
// 备案
export const handleRecord = (data) => {
  return axios({
    url: '/coach/report/' + data,
    method: 'post',
    data
  })
}
// 获取教练员信息
export const getCoachData = (data) => {
  return axios({
    url: '/coach/getCoachData/',
    method: 'post',
    data
  })
}
/**
 * 导入excel
 */
 export const importDevice= (data) => {
  return axios({
    url: '/coach/import',
    method: 'post',
    data
  })
}
/**
 * 导出
 * @param schoolId 驾校ID
 * @param coachnum 教练员编号
 * @param name 教练员姓名
 * @param occupationlevel 职业资格等级1:一级2:二级3:三级4:四级
 * @param teachpermitted 准教车型
 * @param teachType 教练员类型0:理论；1:实操；2:理论和实操
 * @param employstatus 供职状态 0:在职； 1:离职
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=702552
 */
export const exportForExcel = data => {
  return axios({
    url: '/coach/exportExcel',
    method: 'post',
    responseType: 'blob',
    data
  })
}




// WEBPACK FOOTER //
// ./src/http/modules/coach/coach.js